module.exports = __webpack_public_path__ + "img/26.109c6927.jpg";